module.exports = __webpack_public_path__ + "static/media/ThumbnailStill09.03c60dc5.png";